
import { UnmatchedFeature } from "@/components/vin/UnmatchedFeaturesDisplay";
import { NHTSA_SAFETY_FIELDS } from "./feature-matching/constants";

// This function should be updated to compare NHTSA data with DataOne data
export const findUnmatchedSafetyFeatures = (dataOneData: any, nhtsaData: any): UnmatchedFeature[] => {
  const unmatchedFeatures: UnmatchedFeature[] = [];

  // If no nhtsaData is available, return empty array
  if (!nhtsaData) return unmatchedFeatures;

  // If DataOne data is available, we'd use its ADAS features for comparison
  const dataOneAdasFeatures = dataOneData?.adas_features || [];
  
  // Extract names of DataOne ADAS features for matching
  const dataOneFeatureNames = new Set<string>();

  // If DataOne has ADAS features, add them to the set
  if (Array.isArray(dataOneAdasFeatures)) {
    dataOneAdasFeatures.forEach(feature => {
      if (feature.adas_system_name) {
        dataOneFeatureNames.add(feature.adas_system_name.toLowerCase());
      }
      if (feature.adas_system_oem_name) {
        dataOneFeatureNames.add(feature.adas_system_oem_name.toLowerCase());
      }
    });
  }
  
  // Process NHTSA safety fields
  for (const field of NHTSA_SAFETY_FIELDS) {
    const value = nhtsaData[field];
    if (value && value !== "Not Applicable" && value !== "N/A") {
      // Make readable name from field
      const readableName = field
        .replace(/([A-Z])/g, ' $1')
        .replace(/_/g, ' ')
        .trim();
      
      // Check if this feature might already be covered in DataOne data
      const normalizedFieldName = readableName.toLowerCase();
      let isMatched = false;
      
      // Check if any DataOne feature name contains this NHTSA field name
      isMatched = Array.from(dataOneFeatureNames).some(featureName => 
        featureName.includes(normalizedFieldName) || normalizedFieldName.includes(featureName)
      );
      
      // If not matched, add to unmatched features
      if (!isMatched) {
        const normalizedValue = value.toLowerCase();
        let confidence: UnmatchedFeature["confidence"] = "Maybe Installed";
        
        if (normalizedValue.includes("standard")) {
          confidence = "Installed";
        } else if (normalizedValue.includes("optional")) {
          confidence = "Maybe Installed";
        } else if (normalizedValue.includes("no") || normalizedValue.includes("not available")) {
          confidence = "Not Installed";
        }
        
        unmatchedFeatures.push({
          name: readableName,
          value,
          confidence
        });
      }
    }
  }
  
  return unmatchedFeatures;
};
